<template lang="pug">
  .mx-2(:class="{ 'mx-16': $vuetify.breakpoint.mdAndUp }")
    .d-flex.justify-center.py-16(v-if="loading")
      v-progress-circular(indeterminate color="primary")
    v-alert.mt-8(v-else-if="!article" type="info" outlined) 找不到這篇文章，可能尚未發佈或已被移除。
    template(v-else)
      v-img(:src="articleImageUrl(article)" eager max-height="620" contain class="grey lighten-4")
      .mt-6.mx-2.text-h5 {{ article.title }}
      .mt-2.mx-4
        .d-flex.align-center.text-subtitle-1.grey--text
          v-icon(size="14") mdi-calendar-blank-outline
          span.ml-1 {{ article.post_date }}
          v-icon.ml-3(size="14") mdi-eye
          span.ml-1 {{ article.read_num }}{{ $t('News_4') }}
      .mt-6.mx-2.text-body-1.article-content {{ article.content }}
      .mt-6.mx-2(v-if="article.video_url")
        v-btn(:href="article.video_url" target="_blank" rel="noopener noreferrer" outlined color="primary")
          v-icon(left) mdi-play-circle-outline
          | 觀看影片
      .mt-10.mb-16.mx-2
        v-chip.grey--text.text--darken-1.mr-2(v-for="tag in article.tags" :key="tag") {{ tag }}
</template>

<script>
import { articleImageUrl, fetchArticle } from "@/services/articles";

export default {
  name: "NewsInfo",

  data() {
    return {
      article: null,
      loading: true,
    };
  },

  methods: {
    articleImageUrl,
    async loadArticle() {
      this.loading = true;
      try {
        this.article = await fetchArticle(this.$route.params.uid);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    "$route.params.uid": "loadArticle",
  },

  mounted() {
    this.loadArticle();
  },
};
</script>

<style lang="sass" scoped>
.article-content
  white-space: pre-line
  line-height: 1.9
</style>
